/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_metric_schema_conflict_has_history = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This metric has recorded values, so its type or scale range can't be changed and existing options can't be removed. To track something different, add a new metric and deactivate this one.`)
};

const pl_metric_schema_conflict_has_history = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta metryka ma zapisane wartości, więc nie można zmienić jej typu, zakresu skali ani usunąć istniejących opcji. Aby śledzić coś innego, dodaj nową metrykę i dezaktywuj tę.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const metric_schema_conflict_has_history = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.metric_schema_conflict_has_history(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("metric_schema_conflict_has_history", locale)
	if (locale === "en") return en_metric_schema_conflict_has_history(inputs)
	return pl_metric_schema_conflict_has_history(inputs)
};